(function($, Drupal) {
  Drupal.behaviors.navigation = {
    attach: function(context, settings) {
      // Header
      let $header = $('header');
      let $header_items = $('header *');

      const $html = $('html', context);
      const $body = $('body', context);

      // Search toggle variables
      let $search_toggle = $('#js-search-toggle', context);
      let $search_region = $('.region-search').first();
      const $search_input = $('#edit-keyword');

      // Mobile menu toggle variables
      const $mobile_menu_toggle = $('#js-nav-toggle', context);

      // Mega menu toggle variables
      let $main_nav_toggles = $('.js-toggle-dropdown-menu', context);
      let $main_nav_sololinks = $('.primary-nav-item > a', context);
      let $primary_menu = $('.primary-menu', context);
      let $dropdown_nav_toggles = $('.js-toggle-dropdown-menu', context);
      let $dropdown_wrap = $('.dropdown-wrap', context);

      // Subnav toggle variables
      let $sub_nav_toggles = $('.js-mobile-menu-back', context);

      function focusTrap(element) {
        let $tabbable = element.find('button, a').filter(':visible');
        let $first_tabbable = $tabbable.first();
        let $last_tabbable = $tabbable.last();

        // Set focus on first input
        $first_tabbable.focus();

        // Redirect last tab to first input
        $last_tabbable.on('keydown', function(e) {
          if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault();
            $first_tabbable.focus();
          }
        });

        // Redirect first shift+tab to last input
        $first_tabbable.on('keydown', function(e) {
          if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault();
            $last_tabbable.focus();
          }
        });
      }

      // Wraps menu items until a sub group item
      function wrapSubGroups(id) {
        let $menu_items_sub_groups = $('#dropdown-menu-' + id).find('.sub-group');
        $menu_items_sub_groups.each(function(index) {
          $(this).attr('id', 'sub-group-' + index + id);
          let $menu_items_to_wrap = $('#sub-group-' + index + id).nextUntil('li.sub-group').addBack();
          $menu_items_to_wrap.wrapAll('<li class="menu-item-grouped"><ul class="subgroup-list"></ul></li>');
        });

        let $menu_items_left_over = $('#dropdown-menu-' + id + ' > .menu-item').nextUntil('.menu-item-grouped').addBack();
        $menu_items_left_over.each(function(index) {
          for (let i = 0; i < $menu_items_left_over.length; i += 5) {
            $menu_items_left_over.slice(i, i + 5).wrapAll('<li class="menu-item-grouped"><ul class="subgroup-list"></ul></li>');
          }
        });
      }

      // Wraps dropdown menu items in groups of five
      function wrapGroups(id) {
        let $menu_items_to_wrap = $('#dropdown-menu-' + id + ' .menu-item');
        if ($menu_items_to_wrap.length > 5) {
          for (let i = 0; i < $menu_items_to_wrap.length; i += 5) {
            $menu_items_to_wrap.slice(i, i + 5).wrapAll('<li class="menu-item-grouped"><ul class="subgroup-list"></ul></li>');
          }
        }
      }

      $(document).ready(function() {
        let $dropdown_menu_wrap = $('.dropdown-menu-wrap');
        // Group menu items that dont belong to a group
        $dropdown_menu_wrap.each(function(index) {
          $(this).attr('id', 'dropdown-menu-' + index);

          if ($('#dropdown-menu-' + index).find('.sub-group').length !== 0) {
            wrapSubGroups(index);
          }
          else {
            wrapGroups(index);
          }
        });
      });

      // Mobile Nav toggle
      $mobile_menu_toggle.once('navigation-mobile').on('click', function() {
        // Close search
        $header_items.removeClass('search-open');
        $search_region.slideUp(300);

        // Menu toggle logic
        $(this).toggleClass('nav-open');
        if ($(this).hasClass('nav-open')) {
          setTimeout(function() {
            focusTrap($header);
          }, 350);
        }
        $html.toggleClass('no-scroll');
        $body.toggleClass('no-scroll');
        $header.toggleClass('header-fixed');
        $('.dropdown-open').addClass('dropdown-close');

        // Close any open sub menus after nav drawer is closed
        $primary_menu.slideToggle(300, function() {
          if (!$(this).hasClass('nav-open')) {
            $('.dropdown-close').removeClass('dropdown-open');
          }
        });
      });

      $main_nav_toggles.once('check-open').on('focus', function() {
        $main_nav_toggles.removeClass('dropdown-open');
        $('.dropdown-wrap').slideUp(300);
      });

      let $last_link = $('#primary-menu .dropdown-menu-wrap .menu-item', context).last().find('a').first();
      $last_link.keydown(function(e) {
        if (e.code === 'Tab') {
          if (!e.shiftKey) {
            $main_nav_toggles.removeClass('dropdown-open');
            $('.dropdown-wrap').slideUp(300);
          }
        }
      });

      $main_nav_sololinks.once('check-open-links').on('focus', function() {
        $main_nav_toggles.removeClass('dropdown-open');
        $('.dropdown-wrap').slideUp(300);
      });

      // Dropdown menu accordion logic
      $main_nav_toggles.once('navigation-main').on('click', function(event) {
        event.stopPropagation();
        // Close all other super menus
        $main_nav_toggles.not($(this)).removeClass('dropdown-open');
        $(this).removeClass('dropdown-close');

        if (!$(this).hasClass('dropdown-open')) {
          $(this).addClass('dropdown-open');
        }

        if ($(window).width() > 1115) {
          $main_nav_toggles.not($(this)).next('.dropdown-wrap').slideUp(300);
          $(this).next('.dropdown-wrap').slideToggle(300);
        }
      });

      // Sub menu accordion logic
      $sub_nav_toggles.once('navigation-submenu').on('click', function() {
        $(this).parent().prev('button').addClass('dropdown-close');
        setTimeout(function() {
          $header_items.removeClass('dropdown-open');
        }, 300);
      });

      // Search toggle on mobile
      $search_toggle.once('toggle-search').on('click', function() {
        if (!$(this).hasClass('search-open')) {
          $mobile_menu_toggle.removeClass('nav-open');
          $html.removeClass('no-scroll');
          $body.removeClass('no-scroll');
          $header.removeClass('header-fixed');
          $(this).addClass('search-open');
          $search_region.slideDown(300, function() {
            $search_input.focus();
          });
        }
        else {
          $(this).removeClass('search-open');
          $search_region.slideUp(300);
        }

        // Close mobile menu when search is opened
        $('.dropdown-open').addClass('dropdown-close');
        $primary_menu.slideUp(300, function() {
          $('.dropdown-close').removeClass('dropdown-open');
        });
      });

      // Reset and open items on window resize, with breakpoint being desktop view
      // Fire on resize
      $(window, context).once('navigation-resize').resize(function() {
        if ($(window).width() > 1115) {
          $html.removeClass('no-scroll');
          $body.removeClass('no-scroll');
          $header.removeClass('header-fixed');
          $dropdown_nav_toggles.removeClass('dropdown-open');
          $primary_menu.removeAttr('style');
          $dropdown_wrap.removeAttr('style');
          $search_region.removeAttr('style');
          $search_toggle.removeClass('search-open');
        }
      });

      $('#toggle-video-motion').once('toggle-video-motion').on('click', function() {
        let $video = $('.field--name-field-hero-video').find('video');
        $(this).toggleClass('paused');
        if ($video[0].paused) {
          $video[0].play();
        }
        else {
          $video[0].pause();
        }
      });

      // Close nav if click outside of menu detected
      $(document).click(function(event) {
        if ($(window).width() > 1115) {
          let container = $('.dropdown-wrap');
          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(event.target) && container.has(event.target).length === 0) {
            container.slideUp(300);
          }
        }
      });
    }
  };
})(jQuery, Drupal);
